import { render } from "./HeroiconsOutlineOfficeBuilding.vue?vue&type=template&id=338670a8"
const script = {}

import exportComponent from "/Users/mq/Projects/siinadmin/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineOfficeBuilding.vue"]])

export default __exports__